import AcceleratorDoc from "../../models/AcceleratorDoc";
import API from "../../models/API";
import {
  ExtractedTable,
  ExtractedTableDataDto,
} from "../../models/ExtractedTable";
import { TableModel } from "../../models/TableModel";
import { AcceleratorDocMetadataStore } from "../../stores/impl/AcceleratorDocMetadataStore";
// import { RunTable, RunTableReponse } from "../../models/extraction/RunTable";
export { TableExtractor };

class TableExtractor {
  batchClassId: string;
  tableModel: TableModel;
  treatNotFoundAsStale: boolean;
  constructor(
    batchClassId: string,
    matcher: TableModel,
    treatNotFoundAsStale: boolean = true,
  ) {
    this.batchClassId = batchClassId;
    this.tableModel = matcher;
    this.treatNotFoundAsStale = treatNotFoundAsStale;
  }

  async extract(
    acceleratorDoc: AcceleratorDoc,
  ): Promise<ExtractedTable | undefined> {
    if (!this.tableModel.isConfigured()) {
      // return the non extracted place holder lol !
      return new ExtractedTable({
        name: this.tableModel.name,
        rows: [],
        status: "EMPTY",
        tableTemplateData: this.tableModel.toTableModelData(),
      });
    }

    const response = await this.extractTable(acceleratorDoc);
    if (!response) {
      // console.warn(`Error calling API to extract with matcher ${this.tableModel.getModelId()}`);
    }
    if (response && !response!.valid) {
      console.warn(
        `Could not extract Table ${this.tableModel.name} with Matcher ${this.tableModel.getModelId()}`,
        response.reason,
      );
      // console.log(response!.reason);
      return undefined;
    }
    // DEBUG: this should be set by the API, otherwise reuse could not work !
    let extractedTable;
    if (response?.extractedTable) {
      extractedTable = new ExtractedTable(response.extractedTable);
      extractedTable.tableModelId = this.tableModel.getModelId();
    }
    return extractedTable;
  }

  private async extractTable(
    acceleratorDoc: AcceleratorDoc,
  ): Promise<RunTableReponse | null> {
    // return new RunTable(this.batchClassId, this.tableModel.toTableModelData()).extract(acceleratorDoc);
    return await API.post(`/v0/table/extract/`, null, {
      tableModel: this.tableModel.toTableModelData(),
      documentId: acceleratorDoc.uuid,
      docConfigName: acceleratorDoc.classifiedDocType,
      batchClassId: this.batchClassId,
    })
      .then((res) => {
        if (!res.ok && res.status === 404 && this.treatNotFoundAsStale) {
          AcceleratorDocMetadataStore.markAllDocMetadataStale(
            acceleratorDoc.storeId.batchInstanceUuid,
          );
        }
        return res;
      })
      .then((value: Response) => value.json())
      .then((value: RunTableReponseData) => new RunTableReponse(value))
      .catch((error: string) => {
        console.log(error);
        return null;
      });
  }
}

type RunTableReponseData = {
  valid: boolean;
  reason: string;
  extractedTable: ExtractedTableDataDto;
};
class RunTableReponse {
  valid: boolean;
  reason: string;
  extractedTable: ExtractedTableDataDto;

  constructor(data: RunTableReponseData) {
    this.valid = data.valid;
    this.reason = data.reason;
    this.extractedTable = data.extractedTable;
  }
}
